import React, { Component } from 'react'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import PasswordHelpStep1PageUI from './PasswordHelpStep1PageUI.js'

class PasswordHelpStep1PageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
    }
  }

  render() {
    return (
      <PasswordHelpStep1PageUI
        context={this.props.context}
        messageList={this.state.messageList}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getMessages(context)
  }

  getMessages(context) {
    let arr = [
      'c_reset_password',
      'c_email',
      'c_tip_password_reset',
      'c_continue',
      'c_passwd_code',
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_passwd_stp1', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default PasswordHelpStep1PageSF
